import { atom } from 'jotai';

export const siteAtom = atom([
  {
    SiteID: '',
    SiteUID: 0,
    Customer: '',
    Active: 0,
    LastRx: '',
  }
]);